import AppContext from "@lightspeed-invoicing/core-client/frontend/app/Context";
import React, { Component } from 'react';
import DebounceInput from 'react-debounce-input';
import FormattedInputField from "../../sharedComponents/formattedInputField.component.jsx";
import GlobalHelper from "../GlobalHelper.jsx";

class MoneyInputForm extends Component {

    constructor(props, context) {
        super(props, context)
        this.state = {
            currency: this.props.currency || AppContext.getAccount().attributes.currency,
            debounced: this.props.debounced,
            debounceTimeout: this.props.debounceTimeout || 300,
            className: this.props.className || '',
            groupClassName: this.props.groupClassName || '',
            inputClassName: this.props.inputClassName || '',
            disabled: this.props.disabled || false,
            name: this.props.name || '',
            id: this.props.id || '',
            max: this.props.max || null,
            value: this.props.value || '',
            onChange: this.props.onChange || function () { },
            onBlur: this.props.onBlur || function () { },
            onCurrencyChange: this.props.onCurrencyChange || function () { },
            multiCurrency: this.props.multiCurrency || false,
            help: this.props.help || '',

        }
        this.handleFocus = this.handleFocus.bind(this)
        this.setValue = this.setValue.bind(this)
    }

    componentWillReceiveProps(nextProps) {
        this.setState({
            className: nextProps.className || '',
            disabled: nextProps.disabled || false,
            name: nextProps.name || '',
            id: nextProps.id || '',
            max: nextProps.max || null,
            currency: nextProps.currency || AppContext.getAccount().attributes.currency,
            value: nextProps.value || '',
            help: nextProps.help || '',
            onChange: nextProps.onChange || function () { },
            onBlur: nextProps.onBlur || function () { },
            onCurrencyChange: nextProps.onCurrencyChange || function () { },
            multiCurrency: nextProps.multiCurrency || false,
        })
    }

    handleFocus(event) {
        event.target.select()
    }

    isMaxed(value) {
        if (this.state.max === null) {
            return false
        }
        if (parseFloat(value) > parseFloat(this.state.max)) {
            return true
        }
        return false
    }

    setValue(val) {
        if (this.isMaxed(val)) {
            val = this.state.max
        }
        this.setState({
            value: val
        }, () => {
            this.state.onChange(val)
        })
    }

    render() {
        return (
            <div className={this.state.className}>
                {this.state.multiCurrency && GlobalHelper.getEnabledCurrencies().length > 1 ?
                    <ul className="nav nav-tabs border-bottom-0">
                        {GlobalHelper.getEnabledCurrencies().map(currency => {
                            return <li key={currency} className={"nav-item "}>
                                <a className={"nav-link " + (currency === this.state.currency ? 'bg-primary active' : '')}
                                    href="#"
                                    onClick={e => {
                                        e.preventDefault()
                                        this.setState({ currency: currency })
                                        this.state.onCurrencyChange(currency)
                                    }}
                                >
                                    <span
                                        className={'' + (currency === this.state.currency ? 'text-white' : '')}>{currency}</span>
                                </a>
                            </li>
                        })}
                    </ul> : null}
                <div className={"input-group " + this.state.groupClassName}>
                    <div className="input-group-prepend">
                        <div className="input-group-text">{GlobalHelper.getCurrencySign(this.state.currency)}</div>
                    </div>


                    {this.state.debounced ? <DebounceInput
                        key={this.props.key ?? ''}
                        disabled={this.state.disabled}
                        name={this.state.name}
                        id={this.state.id}
                        type="text"
                        className={"form-control " + (this.props.hasNewPriceValue ? "is-invalid " : "") + this.state.inputClassName}
                        placeholder={GlobalHelper.applyLocaleDecimal("0.00", AppContext.getLocale().getLanguage())}
                        value={this.state.value}
                        onChange={(event) => {
                            this.setValue(event.target.value)
                        }}
                        onBlur={(event) => {
                            this.state.onBlur(event.target.value)
                        }}
                        minLength={0}
                        debounceTimeout={this.state.debounceTimeout}
                        autoComplete="off"
                        onFocus={this.handleFocus}
                        onClick={this.handleFocus}
                    /> : <FormattedInputField
                        name={this.state.name}
                        disabled={this.state.disabled}
                        id={this.state.id}
                        type="text"
                        className={"form-control " + (this.props.hasNewPriceValue ? "is-invalid " : "") + this.state.inputClassName}
                        placeholder={GlobalHelper.applyLocaleDecimal("0.00", AppContext.getLocale().getLanguage())}
                        onFocus={this.handleFocus}
                        onClick={this.handleFocus}
                        valueType="money"
                        value={this.state.value}
                        onValueChange={this.setValue}
                        onBlur={(event) => {
                            this.state.onBlur(event.target.value)
                        }}
                    />
                    }
                </div>
                <small className="form-text text-muted">
                    {this.state.help}
                </small>
            </div>
        )
    }
}

export default MoneyInputForm


// WEBPACK FOOTER //
// ./src/common/form/moneyinput.component.jsx